import { Box, Tab, Tabs } from "@mui/material";
import useLanguage from "../../hooks/useLanguage";
import useMemorize from "../../hooks/useMemorize";
import CommonPage from "../../components/common-page";
import RecordingTab from "./tabs/recording.jsx";
import ModelsTab from "./tabs/models.jsx";

const VALID_TABS = new Set(["recording", "models"]);

export default function Settings() {
  const [
    {
      pages: { settings: text },
    },
  ] = useLanguage();

  const [tabRaw, setTab] = useMemorize("settings");
  const tab = VALID_TABS.has(tabRaw) ? tabRaw : "recording";

  return (
    <CommonPage title={text.title} subtitle={text.subtitle}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab value="recording" label={text.tabs.recording} />
          <Tab value="models" label={text.tabs.models} />
        </Tabs>
      </Box>
      {tab === "recording" ? <RecordingTab /> : <ModelsTab />}
    </CommonPage>
  );
}
